import { APP_ROUTES } from '@routes/routes.constants';
import * as React from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import type { UseInvoiceNavigationReturn } from './useInvoiceNavigation.types';

export function useInvoiceNavigation(): UseInvoiceNavigationReturn {
  const navigate = useNavigate();
  const { customerId } = useParams<{ customerId: string }>();
  const basePath = React.useMemo(
    () =>
      // customerId is guaranteed by OrganizationRouteGuard on all /manage/:customerId routes.
      generatePath(APP_ROUTES.MANAGE_INVOICES_PAYMENTS, {
        customerId: customerId as string,
      }),
    [customerId]
  );

  const navigateToInvoice = React.useCallback(
    (accountReceivableId: string): void => {
      navigate(
        generatePath(APP_ROUTES.MANAGE_INVOICES_DETAIL, {
          customerId: customerId as string,
          accountReceivableId,
        })
      );
    },
    [navigate, customerId]
  );

  const navigateToInvoicesList = React.useCallback((): void => {
    navigate(basePath);
  }, [navigate, basePath]);

  return { navigateToInvoice, navigateToInvoicesList };
}
